// removed by extract-text-webpack-plugin
module.exports = {"fountainG":"_2UZAfRfW53mCbukq8NDXtZ","bounce_fountainG":"_2_VoN_3fauXhTl979PMQkg","fountainG_1":"_1eab9x0Kdqko_ZYyV0wCyT","fountainG_2":"_2YU7UrhRRCo3muV61pdpcs","fountainG_3":"_3PZFbiRIS0-k405M_qSnFU","fountainG_4":"_31qTqHVbw29qS0Vb9EPKER","fountainG_5":"_1oMbS_dHBI1OzrqAJ7wE2H","fountainG_6":"inseUcRgnETn59vGeMyY","fountainG_7":"_11TV-t8VBTGE4W7qNEDFUb","fountainG_8":"_3MhDvYmKBfZM07De41mCiX"};


//////////////////
// WEBPACK FOOTER
// ./src/component/Spinner/FountainDrops/style.css
// module id = 1356
// module chunks = 0